import { apiClient, makeServicePlugin, BaseModel } from "@/store/api";

class Config extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = "Config";

    // Define default properties here
    static instanceDefaults() {
        return {
            id: null,
            organisation: {
                name: null,
                regNum: null,
                accentColour: null
            },
            licence: {
                name: null,
                hostingProvider: null,
                ipAddress: null
            }
        };
    }
}
const servicePath = "configs";
const servicePlugin = makeServicePlugin({
    Model: Config,
    service: apiClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin;
